export default "__VITE_PUBLIC_ASSET__d5a63b2e__"